export class Utils {
    static isNumber(n) {
        return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
    }

    static round(value, step = 1.0) {
        const inv = 1.0 / step;
        return Math.round(value * inv) / inv;
    }
}
